import { observer } from 'mobx-react-lite';

import { MobileScreen } from 'components/MobileScreen';
import { OptionsList } from 'components/OptionsList';
import { excludeReverseParams, includeReverseParams } from 'constants/extraParams';
import { useStore } from 'hooks/useStore';

import { ADR } from '../ADR';
import { ReverseGroup } from '../ReverseGroup';

import css from './Mobile.module.css';

const Mobile = () => {
  const {
    app: { i18n },
    filter: { extraParams },
    options,
  } = useStore();

  const { include, exclude } = i18n.extraParams.reverse;

  const actions = {
    cancel: {
      onClick: extraParams.resetExtraParams,
      text: i18n.common.reset,
      ...(extraParams.reverse.isEnabled && { mobileText: i18n.common.clearAll }),
    },
  };

  return (
    <MobileScreen hasBackButton actions={actions} title={i18n.extraParams.label}>
      {extraParams.reverse.isEnabled ? (
        <div className={css.sections}>
          <ReverseGroup className={css.group} mode="include" params={includeReverseParams} title={include} />
          <ReverseGroup className={css.group} mode="exclude" params={excludeReverseParams} title={exclude} />
        </div>
      ) : (
        <>
          <OptionsList
            options={options.getExtraParams()}
            selectedValues={extraParams.params}
            valueProperty="id"
            onChange={extraParams.setParam}
          />

          {extraParams.withADR && <ADR />}
        </>
      )}
    </MobileScreen>
  );
};

const connected = observer(Mobile);

export { connected as Mobile };
